import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function Testimonials() {
  const testimonials = [{
    name: 'Laura G.',
    role: 'Docente de Arte — Primaria',
    initial: 'L',
    quote: '¡Increíble material! Me salvó el año. Las actividades son súper creativas y a los chicos les encantan. Lo recomiendo totalmente.'
  }, {
    name: 'Martín R.',
    role: 'Profesor de Artística — Secundaria',
    initial: 'M',
    quote: 'La sección de secundaria es muy completa. Los proyectos están muy bien estructurados paso a paso. Excelente inversión.'
  }, {
    name: 'Sofía P.',
    role: 'Tallerista Independiente',
    initial: 'S',
    quote: 'Los bonos son lo mejor. Las planificaciones anuales me salvaron el año. Me permite tener todo organizado y variar mis clases siempre.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section id="testimonios" className="w-full bg-white py-20 px-4" data-id="element-99">
      <div className="max-w-7xl mx-auto" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-101">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-102">
            Lo que dicen los Docentes
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-103">
            Colegas que ya transformaron sus clases con el Mega Pack Artística
            Lista.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-104">
          {testimonials.map((testimonial, index) => <motion.div key={index} variants={itemVariants} className="bg-gray-50 rounded-xl p-8 hover:shadow-lg transition-shadow duration-300" data-id="element-105">
              <div className="flex items-center mb-6" data-id="element-106">
                <div className="w-14 h-14 rounded-full bg-red-700 flex items-center justify-center text-white text-xl font-bold" data-id="element-107">
                  {testimonial.initial}
                </div>
                <div className="ml-4" data-id="element-108">
                  <h3 className="font-bold text-gray-900" data-id="element-109">
                    {testimonial.name}
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-110">{testimonial.role}</p>
                </div>
              </div>

              <p className="text-gray-700 leading-relaxed italic" data-id="element-111">
                "{testimonial.quote}"
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}